import { CampaignStatus, CampaignType } from './@x';

export const BLOCKING_BUDGET_INPUT_MESSAGE = 'Budget changes will be applied on';
export const CAMPAIGN_STATUS_OPTIONS = [
  { text: 'Running', id: CampaignStatus.running },
  { text: 'Overbudget', id: CampaignStatus.budgetReached },
  { text: 'Paused', id: CampaignStatus.paused },
  { text: 'Deactivated', id: CampaignStatus.deactivated },
  { text: 'In Review', id: CampaignStatus.inReview },
  { text: 'No CC Added', id: CampaignStatus.noCcAdded },
];

export const companyType: { [key in CampaignType]: string } = {
  lead: 'Leads',
  appt: 'Call Center Leads',
  sales: 'Sales',
  apptWithCustomSchedule: 'After hours',
};

export const CAMPAIGN_TYPE_OPTIONS = [
  { text: 'Call Center Leads', id: CampaignType.appointments },
  { text: 'Leads', id: CampaignType.leads },
  { text: 'Sales', id: CampaignType.sales },
  { text: 'After hours', id: CampaignType.apptWithCustomSchedule },
];

export const BUDGET_SPENT_OPTIONS = [
  {
    text: '80% - 94%',
    id: '1',
    from: 80,
    to: 94,
  },
  {
    text: '95% - 105%',
    id: '2',
    from: 95,
    to: 105,
  },
  {
    text: '105%+',
    id: '3',
    from: 106,
  },
];

export const BLOCKING_MESSAGE = 'Campaign editing is possible from 8:00 AM EST Monday to 10:00 AM EST Friday.';

export const EDIT_CAMPAIGN_PAGE_KEY = 'editCampaignModal';
export const EDIT_CAMPAIGN_MODAL_PAGES = {
  campaign_details: 'campaign_details',
  edit_zips: 'edit_zips',
  min_income: 'min_income',
  weekly_budget: 'budget',
  bid_range: 'bid_range',
};
